<template>
  <div class="form-single-fragment" style="position: relative">
    <el-form
      label-width="100px"
      :size="defaultFormItemSize"
      label-position="right"
      @submit.native.prevent
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="登录名称">
            <el-input
              class="filter-item"
              v-model="formSysUser.formFilter.sysUserLoginName"
              :clearable="true"
              placeholder="登录名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="昵称">
            <el-input
              class="filter-item"
              v-model="formSysUser.formFilter.showName"
              :clearable="true"
              placeholder="登录名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="!multiple">
          <el-form-item label="自定义用户">
            <el-input
              :size="defaultFormItemSize"
              v-model="assignee"
              placeholder="自定义用户"
              style="width: 200px; margin: 0px 10px"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="flex" style="margin-bottom: 15px; text-align: right">
        <el-button
          type="primary"
          :size="defaultFormItemSize"
          @click="refreshFormSysUser(true)"
        >
          查询
        </el-button>
        <el-button
          type="primary"
          :size="defaultFormItemSize"
          @click="refreshFormSysUser(false)"
        >
          重置
        </el-button>
        <el-button
          v-if="$route.query.flowEntryName !== '办公用品购置申请'"
          type="primary"
          :size="defaultFormItemSize"
          @click="setStartUser"
        >
          流程发起人
        </el-button>
        <el-button
          v-if="showAssignee"
          type="primary"
          :size="defaultFormItemSize"
          @click="useAppointedAssignee"
        >
          使用指定审批人
        </el-button>
        <el-button
          type="primary"
          :size="defaultFormItemSize"
          @click="onSubmit"
          :disabled="!canCommit"
        >
          添加用户
        </el-button>
        <!-- </div> -->
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-radio-group
          class="radio-table"
          v-model="selectUserId"
          style="width: 100%"
        >
          <el-table
            :data="formSysUser.sysUserWidget.dataList"
            :size="defaultFormItemSize"
            height="410px"
            header-cell-class-name="table-header-gray"
            row-key="userId"
            @sort-change="formSysUser.sysUserWidget.onSortChange"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              v-if="this.multiple"
              header-align="center"
              :reserve-selection="multiple"
              align="center"
              type="selection"
              width="50px"
              :selectable="canSelect"
            />
            <el-table-column
              v-else
              label=""
              header-align="center"
              align="center"
              width="50px"
            >
              <template slot-scope="scope">
                <el-radio :label="scope.row.userId"> </el-radio>
              </template>
            </el-table-column>
            <el-table-column label="用户名" prop="loginName" />
            <el-table-column label="昵称" prop="showName" />
            <el-table-column label="所属部门" prop="deptName" />
            <el-table-column label="账号类型" prop="userTypeName" />
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                <span>{{
                  formatDateByStatsType(scope.row.createTime, "day")
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24">
            <el-row type="flex" justify="end" style="margin-top: 10px">
              <el-pagination
                :total="formSysUser.sysUserWidget.totalCount"
                :current-page="formSysUser.sysUserWidget.currentPage"
                :page-size="formSysUser.sysUserWidget.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, prev, pager, next, sizes"
                @current-change="formSysUser.sysUserWidget.onCurrentPageChange"
                @size-change="formSysUser.sysUserWidget.onPageSizeChange"
              >
              </el-pagination>
            </el-row>
          </el-col>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findItemFromList } from "@/utils";
import { statsDateRangeMixin } from '@/core/mixins';
import { TableWidget } from '@/utils/widget.js';
import { SystemController } from '@/api';
import { Attendance } from '@/api/attendance'
export default {
  name: 'TaskUserSelect',
  props: {
    // 是否显示指定审批人
    showAssignee: {
      type: Boolean,
      default: true
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 已经被使用的用户列表
    usedUserIdList: {
      type: Array
    },
    flag: {
      type: Boolean,
      default: false
    },
  },
  mixins: [statsDateRangeMixin],
  data () {
    return {
      assignee: undefined,
      // 单选下选中的用户
      selectUserId: undefined,
      // 多选下选中的用户列表
      multiSelectUser: [],
      formSysUser: {
        formFilter: {
          sysUserLoginName: undefined,
          showName: undefined
        },
        formFilterCopy: {
          sysUserLoginName: undefined,
          showName: undefined
        },
        sysUserWidget: new TableWidget(
          this.loadSysUserData,
          this.loadSysUserVerify,
          true,
          false,
          'createTime',
          1
        ),
        isInit: false,
        deptList:[]
      }
    };
  },
  created() {
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onClear () {
      this.onCancel(true);
    },
    setStartUser () {
      this.onCancel(true, {
        /* eslint-disable-next-line */
        loginName: "${startUserName}",
      });
    },
    useAppointedAssignee () {
      this.onCancel(true, {
        /* eslint-disable-next-line */
        loginName: "${appointedAssignee}",
      });
    },
    canSelect (row) {
      if (
        Array.isArray(this.usedUserIdList) &&
        this.usedUserIdList.length > 0
      ) {
        return this.usedUserIdList.indexOf(row.loginName) === -1;
      } else {
        return true;
      }
    },
    onSubmit () {
      let selectUser = this.multiSelectUser;
      if (!this.multiple) {
        if (this.assignee != null && this.assignee !== '') {
          this.onCancel(true, {
            loginName: this.assignee
          });
          return;
        }
        selectUser = findItemFromList(
          this.formSysUser.sysUserWidget.dataList,
          this.selectUserId,
          'userId'
        );
      }
      this.onCancel(true, selectUser);
    },
    handleSelectionChange (values) {
      this.multiSelectUser = values;
    },
    /**
     * 用户管理数据获取函数，返回Primise
     */
    loadSysUserData (params) {
      const name = this.$route.query.flowEntryName
      if (name === '办公用品购置申请') {
        params.sysUserDtoFilter = {
          loginName: this.formSysUser.formFilterCopy.sysUserLoginName,
          showName: this.formSysUser.formFilterCopy.showName,
          serialNo: this.$route.query.serialNo
        }
        return new Promise((resolve, reject) => {
          SystemController.getUserHuiqian(this, params).then(res => {
            resolve({
              dataList: res.data.dataList.map(item => {
                item.userTypeName = item.userTypeDictMap.name
                item.deptName = item.deptIdDictMap.name
                return item
              }),
              totalCount: res.data.dataList.length
            });
          }).catch(e => {
            reject(e);
          });
        });
      }

      
      if (this.getUserInfo.showName === '桑明峰') {
        return new Promise((resolve, reject) => {
          params.loginName= this.formSysUser.formFilterCopy.sysUserLoginName
          params.showName=this.formSysUser.formFilterCopy.showName
          if(!params.showName){
            params.showName = ['孙先群','华锐'].join(',')
          }else{
            if(['孙先群','华锐'].indexOf(params.showName) < 0){
              params.showName = '%$%$%^#$%#$'
            }
          }
          SystemController.getUserDeptList(this, params)
            .then((res) => {
              const type = ['管理员', '系统操作员', '普通操作员']
              Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(rs => {
                let dataList = []
                  dataList = res.data.dataList.map(item => {
                    item.userTypeName = type[item.userType]
                    const obj = rs.data.find(data => data.id === item.deptId  )
                    item.deptName = obj ? obj.name : ''
                    return item
                  })
                 resolve({
                   dataList,
                   totalCount: res.data.totalCount
                 });  
              })
            })
            .catch((e) => {
              reject(e);
            });
        });
      }

      const list4 = ['固定资产购置申请','员工辞职申请表','员工转正审批表'] //,'员工试用期合同签订'
      if (list4.indexOf(name) > -1) {
        const form = JSON.parse(localStorage.getItem('form'))
        if(form.data_33 === '财务部'){
          params.deptIds = '1'
          return new Promise((resolve, reject) => {
            SystemController.getUserDeptList(this, params)
              .then((res) => {
              const type = ['管理员', '系统操作员', '普通操作员']
              Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(rs => {
                let dataList = []
                  dataList = res.data.dataList.map(item => {
                    item.userTypeName = type[item.userType]
                    const obj = rs.data.find(data => data.id === item.deptId  )
                    item.deptName = obj ? obj.name : ''
                    return item
                  })
                  resolve({
                    dataList,
                    totalCount: res.data.totalCount
                  });
                })
              .catch((e) => {
                reject(e);
              });
            });
          })
          return
        }
      }
      const list1 = ['项目进展情况追踪', '员工转正审批表', '员工辞职申请表', '员工试用期合同签订', '员工工资调整申请表','固定资产购置申请','材料管理','机械管理']
      const list2 = ['工程质量、安全隐患整改通知单', '工程质量、安全隐患整改通知/回复单', '工程项目检查意见单', '工程项目整改通知单', '工程项目停工通知单', '工程项目处罚通知单']
      const list3 = ['付款审批单','费用报销单','费用报销申请','付款申请单']
      let deptId = list1.indexOf(name) === -1 ? [] : [2]
      if (!deptId.length) deptId = list2.indexOf(name) === -1 ? [] : [9, 10, 12]
      params.loginName= this.formSysUser.formFilterCopy.sysUserLoginName
      params.showName=this.formSysUser.formFilterCopy.showName
      params.deptIds=!deptId.legnth ? deptId.join(',') : null
      delete params.orderParam
      if((deptId.length && !this.flag) || (this.getUserInfo.showName === '李永培' && list3.indexOf(name) > -1)){
        return new Promise((resolve, reject) => {
        if(!deptId.length && !params.showName){
          params.showName = !deptId.length ? ['孙先群','华锐'].join(',') : ''
        }else{
          if(!deptId.length && ['孙先群','华锐'].indexOf(params.showName) < 0){
            params.showName = '%$%$%^#$%#$'
          }
        }
        SystemController.getUserDeptList(this, params)
          .then((res) => {
            const type = ['管理员', '系统操作员', '普通操作员']
            Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(rs => {
              let dataList = []
              if (this.getUserInfo.showName === '李永培' && list3.indexOf(name) > -1) {
                  dataList = res.data.dataList.map(item => {
                      item.userTypeName = type[item.userType]
                      const obj = rs.data.find(data => data.id === item.deptId  )
                      item.deptName = obj ? obj.name : ''
                      return item
                  })
              }else {
                dataList = res.data.dataList.map(item => {
                  item.userTypeName = type[item.userType]
                  const obj = rs.data.find(data => data.id === item.deptId  )
                  item.deptName = obj ? obj.name : ''
                  return item
                })
              }
               resolve({
                 dataList,
                 totalCount: res.data.totalCount
               });  
            })
          })
          .catch((e) => {
            reject(e);
          });
        });
      }else{
        params.sysUserDtoFilter = {
          loginName: this.formSysUser.formFilterCopy.sysUserLoginName,
          showName : this.formSysUser.formFilterCopy.showName
        }
        return new Promise((resolve, reject) => {
           const type = ['管理员', '系统操作员', '普通操作员']
          SystemController.getUserList(this, params).then(res => {
            resolve({
              dataList: res.data.dataList.map(item => {
                 item.userTypeName = item.userTypeDictMap.name
                 item.deptName = item.deptIdDictMap.name
                 return item
              }),
              totalCount: res.data.totalCount
            });
          }).catch(e => {
            reject(e);
          });
        });
      }
    },
    /**
     * 用户管理数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.formSysUser.formFilterCopy.sysUserLoginName =
        this.formSysUser.formFilter.sysUserLoginName;
      this.formSysUser.formFilterCopy.showName =
        this.formSysUser.formFilter.showName;
      return true;
    },
    /**
     * 更新用户管理
     */
    refreshFormSysUser (reloadData = false) {
      // 重新获取数据组件的数据
      if (reloadData) {
        this.formSysUser.sysUserWidget.refreshTable(true, 1);
      } else {
        
      this.formSysUser.formFilterCopy.sysUserLoginName = ''
      this.formSysUser.formFilterCopy.showName = ''
      this.formSysUser.formFilter.sysUserLoginName = ''
      this.formSysUser.formFilter.showName = ''
        this.formSysUser.sysUserWidget.refreshTable();
      }
      this.formSysUser.isInit = true;
    }
  },
  computed: {
    canCommit () {
      return this.multiple
        ? this.multiSelectUser.length > 0
        : (this.selectUserId != null && this.selectUserId !== '') ||
            this.assignee != null;
    }
  },
  mounted () {
    this.refreshFormSysUser();
  }
};
</script>

<style scoped>
.radio-table >>> .el-radio__label {
  display: none;
}
.flex{
  display: flex;
  /* justify-content: space-between; */
}
</style>
